
































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class YesNoTextareaField extends Vue {
  @Prop({ required: true })
  label!: string

  @Prop({ required: true })
  textAreaLabel!: string

  @Prop({ default: '' })
  value!: string | null

  @Prop({ type: Boolean, default: false })
  required!: boolean

  @Prop({ type: Array, default: () => [] })
  rules!: Array<(v: any) => true | string>

  @Prop({ type: Boolean, default: false })
  disabled!: boolean

  @Prop({ type: String, default: '' })
  dataCy!: string

  @Prop({ type: String, default: '' })
  dataCyTextarea!: string

  @Prop({ type: String, default: '' })
  dataCtextarea!: string

  @Prop({ type: Number, default: 2000 })
  textareaMaxlength!: number

  @Prop({ type: String, default: 'Sim' })
  yesLabel!: string

  @Prop({ type: String, default: 'Não' })
  noLabel!: string

  @Prop({ type: String, default: 'Sim' })
  yesValue!: string

  @Prop({ type: String, default: 'Não' })
  noValue!: string

  localRadioValue: string = ''
  localTextarea: string = ''

  get resolvedDataCyTextarea(): string {
    return this.dataCyTextarea || this.dataCtextarea || ''
  }

  get isYesSelected(): boolean {
    return this.localRadioValue === this.yesValue
  }

  get isNoSelected(): boolean {
    return this.localRadioValue === this.noValue
  }

  get hasContent(): boolean {
    if (this.isNoSelected) return true
    if (this.isYesSelected) return this.localTextarea.trim().length > 0
    return false
  }

  get requiredOrRule() {
    return () => !this.required || this.hasContent || 'Campo obrigatório'
  }

  get sharedRules() {
    return [this.requiredOrRule, ...this.rules]
  }

  get selectorRules() {
    return this.sharedRules
  }

  get textareaRules() {
    if (!this.isYesSelected) return []
    return this.sharedRules
  }

  @Watch('value', { immediate: true })
  onValueChange(newValue: string | null) {
    const normalized = (newValue || '').trim()

    if (normalized === this.noValue) {
      this.localRadioValue = this.noValue
      this.localTextarea = ''
      return
    }

    if (normalized.length > 0) {
      this.localRadioValue = this.yesValue
      this.localTextarea = normalized
      return
    }

    if (this.localRadioValue === this.yesValue) {
      this.localTextarea = ''
      return
    }

    this.localRadioValue = ''
    this.localTextarea = ''
  }

  @Watch('localRadioValue')
  onLocalRadioValueChange(newValue: string) {
    if (newValue === this.noValue) {
      this.localTextarea = ''
      this.emitValue(this.noValue)
      return
    }

    if (newValue === this.yesValue) {
      this.emitValue(this.localTextarea.trim())
      return
    }

    this.emitValue('')
  }

  @Watch('localTextarea')
  onLocalTextareaChange(newValue: string) {
    if (!this.isYesSelected) return
    this.emitValue((newValue || '').trim())
  }

  private emitValue(value: string) {
    this.$emit('input', value)
    this.$emit('change', value)
  }
}
